import { Department } from './department';

export class Province {

    constructor(
        public id?: string,
        public code?: string,
        public name?: string,
        public department?: Department
    ) { }

}



// WEBPACK FOOTER //
// ./src/app/core/entities/province.ts